module.exports = __webpack_public_path__ + "img/favicon.32c57a4e.png";